import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/Dialog';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { Label } from './ui/Label';
import { Select } from './ui/Select';
import { Mitarbeiter, Abteilung } from '../types';
interface AddEmployeeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAdd: (employee: Omit<Mitarbeiter, 'id'>) => void;
}
export function AddEmployeeDialog({
  open,
  onOpenChange,
  onAdd
}: AddEmployeeDialogProps) {
  const [formData, setFormData] = useState({
    name: '',
    abteilung: 'Konstruktion' as Abteilung,
    skills: '',
    verfuegbarkeit: 100,
    email: '',
    telefon: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onAdd({
      ...formData,
      skills: formData.skills.split(',').map(s => s.trim()).filter(Boolean)
    });
    onOpenChange(false);
    setFormData({
      name: '',
      abteilung: 'Konstruktion',
      skills: '',
      verfuegbarkeit: 100,
      email: '',
      telefon: ''
    });
  };
  return <Dialog open={open} onOpenChange={onOpenChange} data-id="element-12">
      <DialogContent className="sm:max-w-[500px] p-0 overflow-hidden gap-0 border-none shadow-2xl" data-id="element-13">
        <div className="bg-muted/30 p-6 border-b" data-id="element-14">
          <DialogHeader data-id="element-15">
            <DialogTitle className="text-xl font-bold tracking-tight" data-id="element-16">
              Neuen Mitarbeiter anlegen
            </DialogTitle>
            <p className="text-sm text-muted-foreground mt-1" data-id="element-17">
              Fügen Sie einen neuen Mitarbeiter zur Datenbank hinzu.
            </p>
          </DialogHeader>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6" data-id="element-18">
          <div className="grid grid-cols-2 gap-4" data-id="element-19">
            <div className="space-y-2" data-id="element-20">
              <Label htmlFor="e-name" className="text-xs font-bold uppercase text-muted-foreground tracking-wider" data-id="element-21">
                Name
              </Label>
              <Input id="e-name" value={formData.name} onChange={e => setFormData({
              ...formData,
              name: e.target.value
            })} placeholder="Max Mustermann" className="bg-muted/10" required data-id="element-22" />
            </div>
            <div className="space-y-2" data-id="element-23">
              <Label htmlFor="abteilung" className="text-xs font-bold uppercase text-muted-foreground tracking-wider" data-id="element-24">
                Abteilung
              </Label>
              <Select id="abteilung" value={formData.abteilung} onChange={e => setFormData({
              ...formData,
              abteilung: e.target.value as Abteilung
            })} className="bg-muted/10" data-id="element-25">
                <option value="Konstruktion" data-id="element-26">Konstruktion</option>
                <option value="E-Konstruktion" data-id="element-27">E-Konstruktion</option>
                <option value="Montage" data-id="element-28">Montage</option>
                <option value="Einkauf" data-id="element-29">Einkauf</option>
                <option value="Inbetriebnahme" data-id="element-30">Inbetriebnahme</option>
              </Select>
            </div>
          </div>

          <div className="space-y-2" data-id="element-31">
            <Label htmlFor="skills" className="text-xs font-bold uppercase text-muted-foreground tracking-wider" data-id="element-32">
              Skills
            </Label>
            <Input id="skills" placeholder="Kommagetrennt (z.B. CAD, SAP, Schweißen)" value={formData.skills} onChange={e => setFormData({
            ...formData,
            skills: e.target.value
          })} className="bg-muted/10" data-id="element-33" />
          </div>

          <div className="space-y-2" data-id="element-34">
            <Label htmlFor="verf" className="text-xs font-bold uppercase text-muted-foreground tracking-wider" data-id="element-35">
              Verfügbarkeit (%)
            </Label>
            <div className="flex items-center gap-4" data-id="element-36">
              <Input id="verf" type="number" min="0" max="100" value={formData.verfuegbarkeit} onChange={e => setFormData({
              ...formData,
              verfuegbarkeit: parseInt(e.target.value)
            })} className="bg-muted/10 w-24" data-id="element-37" />
              <div className="flex-1 h-2 bg-muted rounded-full overflow-hidden" data-id="element-38">
                <div className="h-full bg-primary transition-all duration-500" style={{
                width: `${formData.verfuegbarkeit}%`
              }} data-id="element-39" />
              </div>
            </div>
          </div>
        </form>

        <div className="bg-muted/30 p-4 border-t flex justify-end gap-3" data-id="element-40">
          <Button variant="ghost" onClick={() => onOpenChange(false)} data-id="element-41">
            Abbrechen
          </Button>
          <Button onClick={handleSubmit} className="px-6" data-id="element-42">
            Speichern
          </Button>
        </div>
      </DialogContent>
    </Dialog>;
}